import logger from 'packages/logger';
import memberInfo from '../data/member-info';
import antiForgeryToken from '../data/anti-forgery-token';
import ToggleElementsUI from '../ui/toggle-elements';
import NavigationData from '../data/navigation';
import NavigationFilterData from '../data/navigation-filter';
import MessageBoxUI from '../ui/message-box-ui';
import GoogleTagManager from '../ui/layout/google-tagmanager';
import disableZoomIfAndroidChrome from '../../utils/disable-zoom';
import WindowResize from '../../utils/window-resize';
import TempData from '../data/temp-data';
import Loading from '../ui/loading';
import ModalUI from '../ui/modal-ui';
import ModalTooltipUI from '../ui/modal-tooltip-ui';
import NavigationModal from '../data/navigation-modal';
import Login from '../ui/layout/login';
import FeatureFeedbackLink from '../ui/feature-feedback/feature-feedback-link';
import SavedSearchMonitorTogglerUI from '../ui/saved-search-monitor-toggler-ui';
import WindowLoad from '../../utils/window-load';
import WindowScroll from '../../utils/window-scroll';
import PreventDefault from '../../utils/prevent-default';
import SignupReferralPathCookieCreator from '../ui/layout/signup-referral-path-cookie-creator';
import TriotFlightBridge from '../../utils/triot-flight-bridge';
import { bootReactAds } from 'tradera-components/ads';
import * as LoginSignupEvents from '../ui/layout/login-signup-events';
import { loadModule, handleError } from 'utils/code-split';
import GdprSettings from 'tradera-utils/gdpr-settings';

const attachFlightComponents = initData => {
    Login.attachTo(document);

    NavigationFilterData.attachTo(document);
    // this service is needed even when pushstate is disabled
    NavigationData.attachTo(document, {
        version: initData.version
    });
    GoogleTagManager.attachTo(document);
    PreventDefault.attachTo(document.body);
    ModalUI.attachTo(document.body);
    ModalTooltipUI.attachTo(document.body);
    MessageBoxUI.attachTo('.message-box-wrapper');
    ToggleElementsUI.attachTo('[data-search-filter-box]');
    disableZoomIfAndroidChrome();
    WindowResize.attachTo(document);

    TempData.attachTo('#temp-data');
    Loading.attachTo(document);
    NavigationModal.attachTo(document);
    FeatureFeedbackLink.attachTo(document, {
        initData: initData
    });
    SavedSearchMonitorTogglerUI.attachTo(document.body);
    WindowLoad.attachTo(document);
    WindowScroll.attachTo(document);

    SignupReferralPathCookieCreator.attachTo('[data-reg-user-link]');
    TriotFlightBridge.attachTo(document);

    LoginSignupEvents.TrackLoginSuccessComponent.attachTo(
        '[data-track-login-success]'
    );
    LoginSignupEvents.TrackConnectSuccessComponent.attachTo(
        '[data-track-connect-success]'
    );
    LoginSignupEvents.TrackLoginFailureComponent.attachTo(
        '[data-track-login-failure]'
    );
    LoginSignupEvents.TrackConnectFailureComponent.attachTo(
        '[data-track-connect-failure]'
    );
};

export default initData => {
    const { featureSwitches, pageName } = initData;

    memberInfo.set(initData);
    antiForgeryToken.set(initData);
    attachFlightComponents(initData);

    /* jshint ignore:end */
    if ('gptData' in initData) {
        try {
            bootReactAds(initData);
        } catch (error) {
            logger(error);
        }
    }

    if (!featureSwitches) {
        return;
    }
    if (
        featureSwitches.humany &&
        GdprSettings.isFunctionalEnabled() &&
        (pageName === 'MyTradera' || pageName === 'MyTradera_Invoices')
    ) {
        import(
            /* webpackChunkName: "humany-bot" */ '../../components/humany/humany-bot'
        )
            .then(module => loadModule(module, initData))
            .catch(handleError);
    }

    if (featureSwitches['quick-view']) {
        import(
            /* webpackChunkName: "quick-view" */ '../../components/quick-view/'
        )
            .then(module => loadModule(module))
            .catch(handleError);
    }
};
